import brand from './brand'
import signUp from './signUp'
import createAccount from './createAccount'
import createShop from './createShop'
import login from './login'
import selectLogin from './selectLogin'
import convertRate from './convertRate'
import createBranch from './createBranch'
import tier from './tier'
import theme from './theme'
import payment from './payment'
import addpoint from './addpoint'
import staff from './staff'
import form from './form'

export default {
  brand,
  signUp,
  createAccount,
  createShop,
  login,
  selectLogin,
  convertRate,
  createBranch,
  tier,
  theme,
  payment,
  addpoint,
  staff,
  form
}



// WEBPACK FOOTER //
// ./src/components/V2LOYALTY_REDESIGN/index.js